import {Component} from '@angular/core';

@Component({
  selector: 'iaud-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent {
  isOpened: boolean = false;
  avatar: string = null;

  logout(): void {
    return null;
  }
}
